import firebase from 'firebase/app';
import 'firebase/auth';

class Auth {
	// TODO - Add login method

	logout() {
		firebase.auth().signOut();
		this.$store.dispatch('setAdmin', false);
		this.$store.dispatch('setAuthenticated', false);
	}
}

// Define as singleton
const instance = new Auth();
Object.freeze(instance);

export default instance;
